import {Inject, Injectable, PLATFORM_ID} from '@angular/core';
import {HttpClient, HttpHeaders, HttpParams} from '@angular/common/http';
import { map } from 'rxjs/operators';
import { environment } from '../../../environments/environment';
import {isPlatformBrowser} from '@angular/common';

const headers = new HttpHeaders({
  'Content-Type':  'application/json',
  'Access-Control-Allow-Origin': '*'
});

@Injectable({
  providedIn: 'root'
})

export class ContactService {

  constructor(
    private http: HttpClient
  ) { }

  saveFrontObject(data: any) {
    return this.http.post( environment.apiUrl + '/contact', data)
      .pipe(map((res: any) => {
        return res;
      }));
  }

  saveObject(data: any) {
    return this.http.post( environment.apiUrl + '/admin/contact/saveObject', data, {headers})
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getObjects() {
    return this.http.get( environment.apiUrl + '/admin/contact/getObjects',{headers})
      .pipe(map((res: any) => {
        return res;
      }));
  }

  getObject(id: string | number | boolean) {
    const params = new HttpParams().set('id', id);
    return this.http.get( environment.apiUrl + '/admin/contact/getObject', {params, headers})
      .pipe(map((res: any) => {
        return res;
      }));
  }

  removeObject(id: string | number | boolean) {
    const params = new HttpParams().set('id', id);
    return this.http.get( environment.apiUrl + '/admin/contact/deleteObject', {params, headers})
      .pipe(map((res: any) => {
        return res;
      }));
  }

}


